import { isNil } from 'lodash';
import { View } from '@shared/components/View';
import { MBLoadingIndicator } from '@shared/components/loading';
import { InputUserAndDate } from '@shared/scenes/entity/components/InputUserAndDate';
import { grid } from '@shared/styles';
import { GeolocationSnapshot } from '@shared/types/fieldValues';
import { useListUsers } from '@shared/util/hooks';
import { GeolocationMapPreview } from './GeolocationMapPreview';

interface Props {
  geolocation: GeolocationSnapshot;
  collapsed?: boolean;
  onClear?(): void;
  showUserName?: boolean;
}

export function GeolocationContent({ geolocation, collapsed, onClear, showUserName }: Props) {
  const { users, loading } = useListUsers({
    input: {
      ids: [geolocation?.userId ?? -1],
      excludeSystemUsers: false,
      orderBys: [{ orderBy: 'firstName', direction: 'ASC' }],
    },
    skip: !showUserName || isNil(geolocation.userId),
  });
  const user = users[0];
  const { date } = geolocation;

  if (loading) {
    return (
      <View row center={!collapsed} style={{ height: collapsed ? grid(3) : grid(12) }}>
        <MBLoadingIndicator />
      </View>
    );
  }

  if (collapsed) {
    return (
      <View row centerVertically style={{ width: '100%' }}>
        <View marginRight={1.25}>
          <GeolocationMapPreview
            width={grid(5)}
            height={grid(5)}
            lat={geolocation.coords.lat}
            lon={geolocation.coords.lon}
            onClear={onClear}
          />
        </View>
        <InputUserAndDate user={user} date={date} collapsed />
      </View>
    );
  }

  return (
    <View row>
      <GeolocationMapPreview
        width={grid(12)}
        height={grid(12)}
        lat={geolocation.coords.lat}
        lon={geolocation.coords.lon}
        iconUrl="https://assets.coastapp.com/address-pin.png"
      />
      <View paddingHorizontal={2}>
        <InputUserAndDate user={user} date={date} indent={false} />
      </View>
    </View>
  );
}
